// src/components/ScrollToHashElement.js
import { useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHashElement = () => {
  let location = useLocation();
  
  const hashElement = useMemo(() => {
    if (location.hash) {
      const hash = location.hash.substring(1); // Remove the # character
      return document.getElementById(hash);
    }
    return null;
  }, [location]);

  useEffect(() => {
    if (hashElement) {
      // Wait a bit for the DOM to fully render before scrolling
      setTimeout(() => {
        hashElement.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [hashElement]);

  return null;
};

export default ScrollToHashElement;
